exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n.colorDot--3d356 {\n  width: 15px;\n  height: 30px;\n  margin: 1px;\n  float: right; }\n  .colorDot--3d356.critical--ekX88 {\n    background-color: #e74c3c; }\n  .colorDot--3d356.major--3nPnL {\n    background-color: #e67e22; }\n  .colorDot--3d356.minor--1IO-4 {\n    background-color: #f1c40f; }\n  .colorDot--3d356.none--7yWUd {\n    background-color: #2ecc71; }\n  .colorDot--3d356.error --1OZSX {\n    background-color: #ffffff; }\n\n.indicator--1OUbi {\n  cursor: pointer; }\n\n.statusDate--fXhWU {\n  font-size: 10px;\n  font-style: italic;\n  color: grey;\n  margin: 0px;\n  line-height: 0.75;\n  padding-left: 14px; }\n\n.statusWidget--1VbS3 {\n  width: 250px; }\n\n.statusWidgetText--2xN0g {\n  display: block;\n  line-height: 1.4; }\n\n.status--1N5lm {\n  color: #8f90a5;\n  font-size: 9px; }\n\n.hrStatus--1DMc9 {\n  margin: 10px -15px; }\n\n.statusBadges--2P-wF {\n  line-height: 30px;\n  min-width: 15px;\n  height: 30px;\n  padding: 1px 5px;\n  color: white;\n  font-size: 10px;\n  float: right;\n  margin: 1px; }\n  .statusBadges--2P-wF.critical--ekX88 {\n    background-color: #e74c3c; }\n  .statusBadges--2P-wF.major--3nPnL {\n    background-color: #e67e22; }\n  .statusBadges--2P-wF.minor--1IO-4 {\n    background-color: #f1c40f; }\n  .statusBadges--2P-wF.none--7yWUd {\n    background-color: #2ecc71; }\n\n.noReports--1mdKc {\n  font-style: italic;\n  color: #8f90a5;\n  font-size: 12px; }\n\n.fleetplanLabel--1g_ct {\n  font-size: 12px; }\n", ""]);

// exports
exports.locals = {
	"colorDot": "colorDot--3d356",
	"critical": "critical--ekX88",
	"major": "major--3nPnL",
	"minor": "minor--1IO-4",
	"none": "none--7yWUd",
	"error ": "error --1OZSX",
	"indicator": "indicator--1OUbi",
	"statusDate": "statusDate--fXhWU",
	"statusWidget": "statusWidget--1VbS3",
	"statusWidgetText": "statusWidgetText--2xN0g",
	"status": "status--1N5lm",
	"hrStatus": "hrStatus--1DMc9",
	"statusBadges": "statusBadges--2P-wF",
	"noReports": "noReports--1mdKc",
	"fleetplanLabel": "fleetplanLabel--1g_ct"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"modules":true,"localIdentName":"[local]--[hash:base64:5]"}!./node_modules/sass-loader/lib/loader.js!./src/common/StatusPageWidget/StatusPageWidget.scss
// module id = 545
// module chunks = 4